"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.38 6.51c.1-1.9-.24-3.52-.38-4.07-2.15-1.06-4.98-1-5.01-.99-.06 0-2.89-.07-5.04.99C2.59 3.82.96 11.5 7.98 14.51c2.38-1.02 4-2.69 4.82-4.96l.94.34c-.94 2.61-2.81 4.5-5.57 5.63l-.19.08-.19-.08C-.85 11.99 2.01 2.06 2.04 1.96l.06-.2.18-.1C4.7.37 7.85.45 7.99.45c.1 0 3.26-.08 5.67 1.21l.18.1.06.2c.03.09.57 1.95.49 4.34l.73-.73.71.71-2.05 2.05-2.05-2.05.71-.71.95.95-.01-.01Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    d: "M20.235 10.193c.24-3.173-.367-5.88-.57-6.66-3.285-1.65-7.635-1.553-7.68-1.546-.075 0-4.432-.105-7.717 1.545-.218.84-.908 3.915-.503 7.396.623 5.287 3.375 9 8.205 11.047 3.66-1.553 6.158-4.103 7.403-7.583l1.057.383c-1.387 3.855-4.162 6.66-8.25 8.333l-.21.09-.21-.09C-1.035 17.888 3.21 3.142 3.255 2.992l.068-.225.21-.112C7.103.742 11.79.855 11.993.862c.157 0 4.852-.12 8.422 1.793l.21.112.068.225c.045.143.922 3.15.697 6.93l1.44-1.44.795.795-2.947 2.948-2.948-2.948.795-.795 1.718 1.718-.008-.007Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    d: "M26.98 13.59c.32-4.23-.49-7.84-.76-8.88-4.38-2.2-10.18-2.07-10.24-2.06-.1 0-5.91-.14-10.29 2.06-.29 1.12-1.21 5.22-.67 9.86.83 7.05 4.5 12 10.94 14.73 4.88-2.07 8.21-5.47 9.87-10.11l1.41.51c-1.85 5.14-5.55 8.88-11 11.11l-.28.12-.28-.12C-1.38 23.85 4.28 4.19 4.34 3.99l.09-.3.28-.15C9.47.99 15.72 1.14 15.99 1.15c.21 0 6.47-.16 11.23 2.39l.28.15.09.3c.06.19 1.23 4.2.93 9.24l1.92-1.92 1.06 1.06-3.93 3.93-3.93-3.93 1.06-1.06 2.29 2.29-.01-.01Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    d: "M40.612 20.805c.578-6.652-.742-12.383-1.132-13.868C32.85 3.562 24.045 3.78 23.948 3.78c-.136 0-8.97-.21-15.586 3.157-.405 1.568-1.86 7.83-1.035 14.925 1.245 10.68 6.825 18.173 16.59 22.283 7.418-3.12 12.458-8.273 14.986-15.3l1.762.638c-2.752 7.665-8.273 13.23-16.395 16.552l-.352.143-.353-.143C-1.868 35.655 6.577 6.33 6.667 6.037l.113-.375.345-.187c7.102-3.795 16.433-3.57 16.823-3.563.345-.015 9.667-.24 16.77 3.563l.344.187.113.375c.09.293 1.913 6.533 1.365 14.288l3.225-3.225 1.328 1.327-5.76 5.76-5.76-5.76L36.9 17.1l3.712 3.712v-.007Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    d: "M54.15 27.74c.77-8.87-.99-16.51-1.51-18.49-8.84-4.5-20.58-4.21-20.71-4.21-.18 0-11.96-.28-20.78 4.21-.54 2.09-2.48 10.44-1.38 19.9 1.66 14.24 9.1 24.23 22.12 29.71 9.89-4.16 16.61-11.03 19.98-20.4l2.35.85c-3.67 10.22-11.03 17.64-21.86 22.07l-.47.19-.47-.19C-2.49 47.54 8.77 8.44 8.89 8.05l.15-.5.46-.25c9.47-5.06 21.91-4.76 22.43-4.75.46-.02 12.89-.32 22.36 4.75l.46.25.15.5c.12.39 2.55 8.71 1.82 19.05l4.3-4.3 1.77 1.77-7.68 7.68-7.68-7.68 1.77-1.77 4.95 4.95v-.01Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconPolicyrenewal = function IconPolicyrenewal(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Policy renewal' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "Policyrenewal"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconPolicyrenewal.sizes = [16, 24, 32, 48, 64];
IconPolicyrenewal.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconPolicyrenewal;
exports.default = _default;